import React, { useEffect, useRef, useState } from 'react';
import CustomButton from '../../components/Buttons/Button';
import { Select, DatePicker, Skeleton, Space, Input, Table } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import FloatLabel from '../../components/FloatLabel/floatLabel';
import { useDispatch, useSelector } from 'react-redux';
import { getMultiYearDealDates, setConfirmPopUpModalIsOpen } from '../../store/reducers/orderDashboardSlice';
import moment from 'moment';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import "./confirmPopupForm.css"
interface Props {
  onSubmit: () => void;
  onCancel: () => void;
  selectedSOW: any;
}
const clientEntity = [{ label: 'Something1', value: 'something1' }, { label: 'Something2', value: 'Something2' }, { label: 'Something3', value: 'Something3' }, { label: 'Something 4', value: 'Something4' }, { label: 'Something 5', value: 'Something5' }]
dayjs.extend(customParseFormat);

// const { RangePicker } = DatePicker;

const dateFormat = 'YYYY-MM-DD';

const getFiscalYearTimestamps = () => {
  const startMonthName = "April";
  const endMonthName = "March";
  const quarter = moment().quarter();
  if (quarter == 1) {
    return {
      current: {
        start: moment().subtract(1, 'year').month(startMonthName).startOf('month'),
        end: moment().month(endMonthName).endOf('month')
      }
    };
  } else {
    return {
      current: {
        start: moment().month(startMonthName).startOf('month'),
        end: moment().add(1, 'year').month(endMonthName).endOf('month')
      }
    };
  }
};

const ConfirmPopupForm: React.FC<Props> = ({ onSubmit, onCancel, selectedSOW }) => {
  const dispatch = useDispatch();
  const selectRef = useRef<any>(null);
  const orderDashboardData = useSelector((state: any) => state.orderDashboard);
  const [visibleField, setvisibleField] = useState<boolean>(false);
  const [multiyearDealcheck, setMultiyearDealcheck] = useState<string>('');
  const [yearsofDeal, setYearsofDeal] = useState<string>('');
  const [datetype, setDatetype] = useState<string>('');
  const [startDate, setStartDate] = useState<any>(new Date().toISOString());
  const [endDate, setEndDate] = useState<any>(new Date().toISOString());
  const [isCustomRangeDisabled, setIsCustomRangeDisabled] = useState<boolean>(true);
  const [isCustomDateRange, setIsCustomDateRange] = useState<boolean>(false);
  const multiyearDealcheckOptions = [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }];
  const datetypeOptions = [{ label: 'Fiscal Year', value: 'Fiscal Year' }, { label: 'Calender Year', value: 'Calender Year' }, { label: 'Custom Range', value: 'Custom Range' }];
  const [parentIdDateOptions, setParentIdDateOptions] = useState<any[]>([]);
  const [noOfYearsOptions, setNoOfYearsOptions] = useState<any[]>([]);

  useEffect(() => {
    console.log("confirm popup called");
    if (!orderDashboardData.confirmPopUpModal.isModalOpen) {
      setMultiyearDealcheck('');
      setDatetype('');
      setYearsofDeal('');
      setvisibleField(false);
      setStartDate(new Date().toISOString());
      setEndDate(new Date().toISOString());
      setIsCustomRangeDisabled(true);
    }

  }, [orderDashboardData.confirmPopUpModal.isModalOpen, orderDashboardData.confirmPopUpModal.confirmPopUpData]);

  const handleChangedValue = (id: string, newvalue: any) => {
    selectRef.current.blur();
    if (id === 'yearsofDeal') {
      setYearsofDeal(newvalue);
    }
    if (id === 'multiyearDealcheck') {
      if (newvalue === 'Yes') {
        setMultiyearDealcheck('Yes');
        setvisibleField(true);
        setParentIdDateOptions([]);
        setNoOfYearsOptions([]);
        setYearsofDeal("");
        setDatetype('');
        
      }
      else {
        setMultiyearDealcheck('No');
        setvisibleField(false);
        setParentIdDateOptions([]);
        setNoOfYearsOptions([]);
        setYearsofDeal("");
        setDatetype('');
      }
      setIsCustomDateRange(false);
    }
    if (id === 'datetype') {
      if (newvalue === 'Fiscal Year') {
        const dates = getFiscalYearTimestamps();
        setDatetype('Fiscal Year');
        setStartDate(moment(dates.current.start).format('YYYY-MM-DD'));
        setEndDate(moment(dates.current.end).format('YYYY-MM-DD'));
        setIsCustomRangeDisabled(true);
        setIsCustomDateRange(false);
        setParentIdDateOptions([]);
        setNoOfYearsOptions([]);
        setYearsofDeal("");
        getNumberOfyearOptions("fiscal",moment(dates.current.start).format('YYYY-MM-DD'),moment(dates.current.end).format('YYYY-MM-DD'));
      } else if (newvalue === 'Calender Year') {
        const startOfYear = moment().startOf('year');
        const endOfYear = moment().endOf('year');

        const calendarYearStartDate = startOfYear.format('YYYY-MM-DD');
        const calendarYearEndDate = endOfYear.format('YYYY-MM-DD');
        setDatetype('Calender Year');
        setStartDate(calendarYearStartDate);
        setEndDate(calendarYearEndDate);
        setIsCustomRangeDisabled(true);
        setIsCustomDateRange(false);
        setParentIdDateOptions([]);
        setNoOfYearsOptions([]);
        setYearsofDeal("");
        getNumberOfyearOptions("calender",calendarYearStartDate,calendarYearEndDate);
      }
      else {
        setDatetype('Custom Range');
        setIsCustomRangeDisabled(false);
        setIsCustomDateRange(true);
        setParentIdDateOptions([]);
        setNoOfYearsOptions([]);
        setYearsofDeal("");
        let startDate="";
        let endDate="";
        if(moment().add(1,'year').subtract(1,'day').isBefore(selectedSOW.sowEndDate)){
          startDate = moment().toISOString();
          endDate = moment().add(1, 'year').subtract(1,'day').toISOString();
        }
        else{
          startDate =  moment(selectedSOW.sowEndDate).subtract(1,'year').add(1,'day').toISOString();
          endDate = selectedSOW.sowEndDate;
        }
        setStartDate(startDate);
        setEndDate(endDate);
        getNumberOfyearOptions("custom",startDate,endDate);
      }
    }
    if (id === 'customDateSelection_startDate') {
      setStartDate(newvalue);
      setEndDate(moment(newvalue).add(1,'year').subtract(1,'day').format(dateFormat));
      setParentIdDateOptions([]);
      setNoOfYearsOptions([]);
      setYearsofDeal("");
      getNumberOfyearOptions("custom",newvalue,moment(newvalue).add(1,'year').subtract(1,'day').format(dateFormat));
    }
    else if (id === 'customDateSelection_endDate') {
      // setStartDate(newvalue[0]);
      setEndDate(newvalue);
      // getNumberOfyearOptions("custom",newvalue[0],newvalue[1]);
    }
  };
  const { RangePicker } = DatePicker;
  const handleCancel = () => {
    setIsCustomDateRange(false);
    dispatch(setConfirmPopUpModalIsOpen({ isModalOpen: false, confirmPopUpData: {} }));
    onCancel();
  }
  const handleSubmit = () => {
    console.log("submit called");
    if (multiyearDealcheck == 'Yes') {
      dispatch(setConfirmPopUpModalIsOpen({
        isModalOpen: false, confirmPopUpData: {
          multiyearDealcheck: multiyearDealcheck,
          yearsofDeal: yearsofDeal,
          datetype: datetype,
          startDate: startDate,
          endDate: endDate
        }
      }));
    }
    else {
      dispatch(setConfirmPopUpModalIsOpen({ isModalOpen: false, confirmPopUpData: {} }));
    }
    onSubmit();
  }
  const validateConfirmPopUp = () => {
    if (multiyearDealcheck == 'No') {
      return true;
    }
    else if (multiyearDealcheck == 'Yes' && yearsofDeal !== '' && datetype !== '' && startDate !== '' && endDate !== '') {
      return true;
    }
    else {
      return false;
    }
  }
  const handleKeyDown = (e: any) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "e" || e.key === "E" || e.key === "." || e.key === "-" || e.key === "+") {
      e.preventDefault();
    }
  };
  const getNumberOfyearOptions = (dateType: any,fromDate:any, toDate: any) => {
    dispatch(getMultiYearDealDates({values:{ multiyearType: dateType, sowStartDate: selectedSOW.sowStartDate, sowEndDate: selectedSOW.sowEndDate, fromDate: fromDate, toDate: toDate }})).then((response: any) => {
      if (response.type === 'orderDashboard/getMultiYearDealDates/fulfilled') {
          setParentIdDateOptions( response.payload.multiYearResponse ||[]);
          let options =[];
          for(let i=2;i<=response.payload.totalResult;i++){
            options.push({label:i,value:i});
          }
          setNoOfYearsOptions(options);
          if(response.payload.totalResult>1){
            setYearsofDeal(response.payload.totalResult.toString());
          }
      }
      else{
        rejectedApiMessage(response.payload);
      }
    });
  }

  const getParentIDDates = (parentIds: any,yearsofDeal:any) => {
    let data = [];
    if (parentIds.length > 0) {
      for(let i=0;i<yearsofDeal;i++){
        data.push(parentIds[i]);
      }
    }
    return data;
  }
  return (
    <div style={{ background: '#F2F6FA', margin: '15px', padding: '15px' }}>
      <div className="form-component" style={{ maxWidth: '100%' }}>
        <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:'10px',font: 'normal normal bold 12px/16px Nunito Sans'}}>
          <div><span>SOW Start Date : </span> &nbsp; <span>{selectedSOW.sowStartDate}</span></div>
          <div><span>SOW End Date : </span> &nbsp; <span>{selectedSOW.sowEndDate}</span></div>

        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }} className='custom-fieldcolumn'>
          <FloatLabel label="Is It a Multi Year Deal ? *" value={multiyearDealcheck}>
            <Select
              showSearch={false}
              allowClear={false}
              size='middle'
              ref={selectRef}
              style={{ width: 400, height: 58, marginRight: '10px' }}
              placeholder="Select Multi Year Deal"
              optionFilterProp="children"
              value={multiyearDealcheck}
              onSelect={(value: string) => handleChangedValue('multiyearDealcheck', value)}
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={multiyearDealcheckOptions}
            >
            </Select>
          </FloatLabel>
          <div>
            {
              visibleField && <FloatLabel label="Choose Date Range Type? *" value={datetype}>
                <Select
                  showSearch={false}
                  allowClear={false}
                  size='middle'
                  ref={selectRef}
                  style={{ width: 400, height: 58, marginRight: '10px' }}
                  placeholder="Select Date Range Type"
                  optionFilterProp="children"
                  value={datetype}
                  onSelect={(value: string) => handleChangedValue('datetype', value)}
                  filterOption={(input: any, option: any) =>
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  options={datetypeOptions}
                >
                </Select>
              </FloatLabel>
            }
          </div>
          {
          visibleField && <div>
            {/* <Space direction="vertical" size={12} style={{ marginBottom: 8 }}>
              <label>Start Date  -  End Date *</label>
              <RangePicker
                value={[dayjs(startDate, dateFormat), dayjs(endDate, dateFormat)]}
                disabledDate={(current: any) => current && current < moment(selectedSOW.sowStartDate)|| current!==moment(selectedSOW.sowEndDate) || current > moment(selectedSOW.sowEndDate)}
                size="middle"
                hideDisabledOptions={true}
                inputReadOnly ={true}
                
                allowClear={false}
                onChange={(date: any, dateString: any) => { handleChangedValue('customDateSelection', dateString) }}
                disabled={isCustomRangeDisabled}
              />
            </Space> */}

            <Space direction="vertical" size={12} style={{ marginBottom: 8, marginRight:10 }}>
              <label>Start Date*</label>
              <DatePicker
                value={dayjs(startDate, dateFormat)}
                disabledDate={(current: any) => current && current < moment().subtract(1,'year') || current < moment(selectedSOW.sowStartDate) || current > moment(selectedSOW.sowEndDate).subtract(1,'year').add(1,'day')}
                size="middle"
                inputReadOnly ={true}
                
                allowClear={false}
                onChange={(date: any, dateString: any) => { handleChangedValue('customDateSelection_startDate', dateString) }}
                disabled={isCustomRangeDisabled}
              />
            </Space>
            <Space direction="vertical" size={12} style={{ marginBottom: 8 }}>
              <label>End Date*</label>
              <DatePicker
                value={dayjs(endDate, dateFormat)}
                disabledDate={(current: any) => current && current < moment(selectedSOW.sowStartDate)|| current > moment(selectedSOW.sowEndDate)}
                size="middle"
                inputReadOnly ={true}
                
                allowClear={false}
                onChange={(date: any, dateString: any) => { handleChangedValue('customDateSelection_endDate', dateString) }}
                disabled={true}
              />
            </Space>
          </div>
        }
          <div>
            {visibleField &&
              // <InputTextBox
              //   label="Enter Number Of Years"
              //   value={yearsofDeal}
              //   placeholder="Enter Number of Years"
              //   id="yearsofDeal"
              //   required={true}
              //   disabled={false}
              //   onChange={(_id, yearsofDealVal, currentValue) => handleChangedValue(_id, yearsofDealVal)}

              // />
              <FloatLabel label="Number Of Years *" value={yearsofDeal}>
                <Select
                  showSearch={false}
                  allowClear={false}
                  size='middle'
                  ref={selectRef}
                  style={{ width: 400, height: 58, marginRight: '10px' }}
                  placeholder="Select Number Of Years"
                  optionFilterProp="children"
                  value={yearsofDeal}
                  disabled = {true}
                  onSelect={(value: string) => handleChangedValue('yearsofDeal', value)}
                  filterOption={(input: any, option: any) =>
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  options={noOfYearsOptions || []}
                >
                </Select>
              </FloatLabel>
              // <FloatLabel label="Enter Number Of Years *" value={yearsofDeal}>
              //   <Input
              //     size='middle'
              //     style={{ width: 400, height: 58, marginRight: '10px',paddingTop:'15px' }}
              //     value={yearsofDeal}
              //     type='number'
              //     min={0}
              //     step={1}
              //     pattern="[0-9]"
              //     onKeyDown={handleKeyDown}
              //     disabled = {datetype?false:true}
              //     onWheel={(e) => {
              //       const target = e.target as HTMLInputElement;
              //       target.blur()
              //     }}
              //     onChange={(e) => handleChangedValue('yearsofDeal', e.target.value)}
              //   />
              // </FloatLabel>
            }
          </div>
        </div>
        { yearsofDeal &&
          <div>
          <p className='parentIdOptions-heading'>Parent Ids Will be created for the below date ranges</p>
          < Table
                          style={{ margin: '10px 0' }}
                          showHeader={true}
                          scroll={{y: 150}}
                          bordered columns={
                              [   
                                    {
                                      title: 'Sl.no.',
                                      dataIndex: 'noParentIds',
                                      key: 'noParentIds',
                                      width: 70,
                                      render(value, record, index) {
                                        return <span>{index+1}</span>
                                      },
                                    }
                                  ,{
                                      title: 'Start Date',
                                      dataIndex: 'startDate',
                                      key: 'startDate',
                                      
                                  },
                                  {
                                    title: 'End Date',
                                    dataIndex: 'endDate',
                                    key: 'endDate',
                                
                                  }
                              ]} dataSource={getParentIDDates(parentIdDateOptions,yearsofDeal) || []} pagination={false} />

                  <p className='parentIdOptions-note'>Note: If you don't want to create multiple parent Ids for above mentioned dates. Please select "Is Multi Year Deal" as "NO", then only 1 parent Id will be created with start Date as SOW start date and end Date as SOW end date. </p>
          </div>}
          {parentIdDateOptions.length ===1 && <div>
            <p className='parentIdOptions-note'>Note: For the above selections only 1 parent Id creation is available start date as {parentIdDateOptions[0].startDate} and end date as {parentIdDateOptions[0].endDate}. For this please proceed with non multi year deal. </p>
            </div>}
      </div>
      <div className="form-buttons" style={{ display: 'flex', justifyContent: 'end', marginTop: "20px" }}>
        <CustomButton label="Cancel" type="cancel" onClick={() => handleCancel()} />
        <CustomButton label="Submit" type="submit" disabled={!validateConfirmPopUp()} onClick={() => handleSubmit()} />
      </div>
    </div>
  );
};

export default ConfirmPopupForm;